import { Center, Loader, Overlay } from "@mantine/core";

export const GlobalLoaderOverlay = ({
  visible = false,
  h = "100vh",
  overlayColor = "white",
  style = {},
}) => {
  if (!visible) return null;

  return (
    <Overlay color={overlayColor} blur={1} h={h} style={{ zIndex: 9999, ...style }}>
      <Center h={h}>
        <Loader size="lg" />
      </Center>
    </Overlay>
  );
};
